window.addEventListener('load', setHeaderHeightVariable);
window.addEventListener('resize', setHeaderHeightVariable);
window.addEventListener('orientationchange', setHeaderHeightVariable);

function setHeaderHeightVariable() {
    const header = document.querySelector('.header-component') as HTMLElement;
    const headerHeight = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}